

export default {
  // getItem: state => (productId) => state.products.find((product) => product.id == productId),
}
